'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var _enUS = require('./icons/en-US');

var _enUS2 = _interopRequireDefault(_enUS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({
  IndexFilters: {
    filters: '{quantity, plural,\n  =0 {フィルター}\n  =1 {1つのフィルター}\n  ' + 'other {#個のフィルター}\n}'
  }
}, _enUS2.default, {
  Active: 'アクティブ',
  Activate: 'アクティブ化',
  Activated: 'アクティブ化済み',
  Add: '追加',
  add: '追加',
  Alerts: 'アラート',
  All: 'すべて',
  ampm: 'ampm',
  Arc: '円弧',
  AxisLabel: '{orientation}軸',
  area: '領域',
  Bar: 'バー',
  bar: 'バー',
  Blank: '空白',
  Box: 'ボックス',
  Carousel: 'カルーセル',
  Category: 'カテゴリ',
  Circle: '円',
  Chart: 'グラフ',
  Children: '子',
  Clear: 'クリア',
  Cleared: 'クリア済み',
  Close: '閉じる',
  'Close Menu': 'メニューを閉じる',
  Completed: '完了',
  'Connects With': '接続先',
  created: '作成済み',
  Critical: '重大',
  'Currently Active': '現在アクティブ',
  'Date Selector': '日付セレクター',
  'Date Time Icon': '日付時刻セレクターを開く',
  day: '日',
  Disabled: '無効',
  Distribution: '配布',
  Email: '電子メール',
  'Enter Select': 'Enterを押して選択',
  Error: 'エラー',
  Filter: 'フィルター',
  Footer: 'フッター',
  Grommet: 'Grommet',
  HotSpotsLabel: 'ホットスポット: 矢印キーを押して対話操作する',
  'GraphValues': 'グラフには{count}個の項目があります。最高は{highest}、' + ' 最小は{smallest}です',
  hour: '時間',
  'Grommet Logo': 'Grommetロゴ',
  'Layer': 'レイヤー',
  List: 'リスト',
  line: '線',
  'Loading': 'ロード中',
  loginInvalidPassword: 'ユーザー名とパスワードを指定してください。',
  'Log In': 'ログイン',
  Logout: 'ログアウト',
  'Main Content': 'メインコンテンツ',
  Max: '最大',
  Menu: 'メニュー',
  Meter: 'メートル',
  Min: '最小',
  minute: '分',
  model: 'モデル',
  modified: '変更済み',
  monitor: 'モニター',
  month: '月',
  'Multi Select': '複数選択',
  Name: '名前',
  'Navigation Help': 'ナビゲーションには矢印キーを使用します',
  'Next Month': '次の月',
  'Next Slide': '次のスライド',
  'No Relationship': '関係なし',
  'Notification': '通知',
  OK: 'OK',
  Open: '開く',
  Parent: '親',
  Parents: '親',
  Parts: '部品',
  Part: '部品',
  Password: 'パスワード',
  'Previous Month': '前の月',
  'Previous Slide': '前のスライド',
  'Previous Tiles': '前のタイル',
  'Remember me': 'ユーザー名を保存する',
  Resource: 'リソース',
  Running: '実行中',
  Search: '検索',
  'Match Results': 'There {count, plural,\n      =0 {is no match}\n      one {is # match}\n      other {are # matches}\n  }',
  second: '秒',
  'Select Icon': '選択ドロップを開く',
  Selected: '選択済み',
  'Selected Multiple': '{count, plural,\n      =0 {none}\n      one {# value}\n      other {# values}\n  }',
  'Skip to': 'スキップ先',
  'Slide Number': 'スライド{slideNumber}',
  Sort: 'ソート',
  Spinning: '回転',
  Spiral: 'スパイラル',
  State: '状態',
  Status: 'ステータス',
  Subtract: '減算',
  SunBurst: 'サンバースト',
  'Tab Contents': '[{activeTitle}] タブの内容',
  Table: 'テーブル',
  Tasks: 'タスク',
  Tiles: 'タイル',
  Time: '時刻',
  Title: 'タイトル',
  Today: '今日',
  Topology: 'トポロジ',
  Total: '合計',
  Threshold: 'しきい値',
  Unknown: '不明',
  Username: 'ユーザー名',
  uri: 'URI',
  Value: '値',
  Warning: '警告',
  year: '年'
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/ja-JP.js
// module id = 131
// module chunks = 0